import {Close as CloseIcon} from '@mui/icons-material';

import {Box, Button, Link as MuiLink, Modal} from '@mui/material';
import * as React from 'react';

const cookies = [
    {
        name: 'JSESSIONID',
        source: 'WebSphere',
        goal: 'Ce cookie stocke l’identifiant d’une session, qui communique entre l’application WebSphere et le navigateur de l’utilisateur.',
        moreInfo: '',
    },
];

const FullscreenModal = ({title, children}) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <MuiLink sx={linkStyle} onClick={handleOpen} underline="none" variant="button" >
                {title}
            </MuiLink>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={ModalStyle}
            >
                <Box sx={BoxStyle}>
                    <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button onClick={handleClose}>
                            <CloseIcon color="action" />
                        </Button>
                    </Box>
                    {children}
                </Box>
            </Modal>
        </>
    );
};

export default FullscreenModal;

const BoxStyle = (theme) => ({
    backgroundColor: theme.palette.process_black.contrastText,
    margin: '2rem',
    padding: '2rem',
    overflow: 'scroll',
    maxHeight: 'calc(100% - 4rem)',
    '&:focus-visible': {
        outline: 'none',
    },

    '& p': {
        mt: 2,
        textAlign: 'justify',
    },
});

const linkStyle = {backgroundColor: 'transparent', border: 'none', cursor: 'pointer'};

const ModalStyle = {display: 'flex', justifyContent: 'center', alignItems: 'center'};
